import { createSelector } from 'reselect';

const statePolicySelector = (state) => state.policy.items;
const statePaymentSelector = (state) => state.payment;

const onetimePaymentSelector = createSelector([statePaymentSelector], (payment) => {
	return { ...payment.onetime };
});

const settingsPaymentSelector = createSelector([statePaymentSelector], (payment) => {
	return { ...payment.settings };
});

const authPaymentSelector = createSelector([statePaymentSelector], (payment) => {
	return { ...payment.auth };
});

const banksPaymentSelector = createSelector([statePaymentSelector], (payment) => {
	return { ...payment.banks };
});

const scheduledPaymentSelector = createSelector([statePaymentSelector], (payment) => {
	return [...payment.scheduled];
});

const paymentInfo = (policy, accountPolicies) => {
	const { outstandingBalance, payInFullAmount, isPartOfAccountBill, accountOutstandingBalance, accountPayInFull, accountBillId, isPrimaryAccountPolicy, accountNumber } = policy.billing;

	return {
		selected: false,
		displayName: accountNumber || policy.policyNumber,
		policyHolder: policy.policyHolder,
		policyNumber: policy.policyNumber,
		imageNumber: policy.policyImageNum,
		policyId: policy.policyId,
		outstandingBalance,
		payInFullAmount,
		isPartOfAccountBill,
		isPrimaryAccountPolicy,
		accountOutstandingBalance,
		accountPayInFull,
		accountBillId,
		accountNumber,
		accountPolicies,
	};
};

export const selectablePoliciesSelector = createSelector([statePolicySelector], (items) => {
	var selectablePolicies = [];
	items
		.map((policy) => {
			const { accountNumber } = policy.billing;
			const accountPolicies = items.filter((i) => i.billing.isPartOfAccountBill && !i.billing.isPrimaryAccountPolicy && i.billing.accountNumber === accountNumber).map((i) => i.policyNumber);

			policy.paymentInfo = paymentInfo(policy, accountPolicies);

			if (policy.futurePolicy) {
				policy.futurePolicy.paymentInfo = paymentInfo(policy.futurePolicy, accountPolicies);
			}

			return policy;
		})
		.forEach((policy) => {
			selectablePolicies.push(policy);
			if (policy.futurePolicy) {
				policy.futurePolicy.paymentInfo.displayName = policy.futurePolicy.paymentInfo.displayName + " (Renewal)"
				selectablePolicies.push(policy.futurePolicy);
			}
		});

	selectablePolicies.sort((a, b) => a.policyNumber.localeCompare(b.policyNumber));
	return selectablePolicies;
});

export const payablePoliciesSelector = createSelector([selectablePoliciesSelector], (items) => {
	return items.filter((p) => { 
		if(p.billing.isPartOfAccountBill && !p.billing.isPrimaryAccountPolicy) {
			const primaryAccountPolicy = items.find(pp => pp.billing.accountNumber === p.billing.accountNumber && pp.billing.isPrimaryAccountPolicy);
			return primaryAccountPolicy.status !== 'History';
		}

		return p.status !== 'History';
	});
});

export const paymentSelector = createSelector([selectablePoliciesSelector, onetimePaymentSelector, settingsPaymentSelector, authPaymentSelector, banksPaymentSelector, scheduledPaymentSelector, payablePoliciesSelector], (policies, onetime, settings, auth, banks, scheduled, payablePolicies) => {
	return { policies, payablePolicies, onetime, settings, auth, banks, scheduled };
});
